import { Component } from "@angular/core";
import { ApplicationService } from "@core/data/application.service";
import { AppConstants } from "@core/constants/app";
import { map, switchMap } from "rxjs/operators";
import dayjs from "dayjs";
import * as momentTZ from "moment-timezone";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Generic } from "@core/interfaces/entities/generic";
import { TranslateService } from "@ngx-translate/core";
import { FeatureFlagsService } from "@core/services/feature-flags.service";
import { ENABLE_BLUE_BUTTON, ENABLE_HRA_LINK } from "@core/constants/feature-flags";
import { ConfigService } from "@core/data/config.service";

@Component({
    selector: "app-confirmation",
    templateUrl: "./confirmation.component.html",
    styleUrls: ["./confirmation.component.scss"],
    standalone: false,
})
export class ConfirmationComponent {
    public readonly translationPrefix = "pages.confirmation";
    readonly backButtonTranslation = "wizard.actions.backToDashboard";
    readonly FF_ENABLE_HRA_LINK = ENABLE_HRA_LINK;
    public readonly summary$: Observable<Generic>;

    constructor(
        private conf: ConfigService,
        private applicationService: ApplicationService,
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService,
        private featureFlags: FeatureFlagsService,
    ) {
        const applicationId = this.route.snapshot.paramMap.get("applicationId");
        this.summary$ = this.conf.populate().pipe(
            switchMap(() => this.applicationService.getStepData(applicationId, AppConstants.API_STEP_REVIEW)),
            map((response: Generic) => ({
                ...response,
                ...{
                    applicationYear: response.coverageEffectiveDate.slice(0, 4),
                    materialId: AppConstants.APPLICATION_MATERIAL_IDS[dayjs(response.requestedEffectiveDate, "YYYY-MM-DD").year()],
                    transaction: {
                        userFullName: `${response.firstName} ${response.lastName}`,
                        timestamp: momentTZ.utc(response.submittedAt).tz("America/New_York").format("MM/DD/YYYY h:mm a"),
                        transactionId: response.confirmationCode,
                    },
                    blueButton: {
                        planName: response.planSelection.name,
                        termsUrl: AppConstants.TERMS_AND_CONDITIONS_URL_MAPPING()[this.translate.currentLang],
                        privacyUrl: AppConstants.PRIVACY_POLICY_URL_MAPPING()[this.translate.currentLang],
                    },
                    hra: {
                        hraUrl: this.conf.getHraConfig()?.url ?? "",
                    },
                },
            })),
        );
    }

    public blueButtonClick() {
        window.open(this.conf.getBlueButtonConfig["url"], "_blank");
    }

    goBackToDashboard(): void {
        this.router.navigate([AppConstants.DASHBOARD_PAGE], {
            state: { skipLanguageModal: true },
        });
    }

    get showBlueButton() {
        return this.featureFlags.isFeatureEnabled(ENABLE_BLUE_BUTTON);
    }
}
